module.exports = __webpack_public_path__ + "img/Seychelles.cfc36262.gif";